<div class="GOP-send-request-container">
  <button [class.primary-button-inactive]="disableGopButton" class="primary-button send-request-button"
          [disabled]="disableGopButton" (click)="sendRequest()">
            {{"GOP-send-request" | translate}}
  </button>
</div>
